var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "26.000000pt",
    height: "26.000000pt",
    viewBox: "0 0 26.000000 26.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,26.000000) scale(0.100000,-0.100000)",
    fill: "#f97316",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 234 c-31 -16 -44 -51 -34 -90 8 -29 103 -124 126 -124 23 0 118 92 125 123 11 42 -2 75 -36 92 -27 14 -33 14 -60 1 -25 -13 -33 -13 -57 0 -33 17 -30 17 -64 -2z m73 -20 c16 -15 20 -15 41 0 46 32 88 9 88 -49 0 -27 -10 -42 -51 -82 -27 -26 -54 -48 -59 -48 -5 0 -32 22 -60 49 -40 39 -50 55 -50 82 0 56 51 84 91 48z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHeartIcon);
export default __webpack_public_path__ + "static/media/whiteHeartIcon.74bb028fa4baaca0910eeb732551e9a7.svg";
export { ForwardRef as ReactComponent };